import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    logsTab,
    logsTabKey,
    metadataTab,
    referencesUsedByTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import resource from "./resource";

const resourceName = "secret";

const config: ResourceConfig = {
    label: "Secret",
    icon: IconCollection.shieldKeyOutline,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: logsTabKey,
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, commentsTab.tab, referencesUsedByTab.tab, metadataTab.tab],
                content: [
                    logsTab.content,
                    commentsTab.content,
                    referencesUsedByTab.content,
                    metadataTab.content,
                ],
            },
        },
    ],
    actions: {
        shown: [],
        hidden: [
            duplicateActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
    graphql: {
        resource: resourceName,
        // NB: `value` is intentionally NOT requested. A SECRET's value is
        // encrypted at rest and masked (`*protected*`) on every external read
        // (REST/GraphQL/MCP), so reading it would only yield the mask. The form
        // treats it as write-only (see the `value` field below). `has_value`
        // says whether a value is stored, so the button reads "Set" or "Change".
        resourceBody: `
            ${resource.graphql.resourceBody}
            has_value
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $value: SchemalessData,
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            value: $value,
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $value: SchemalessData,
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            value: $value,
        `,
    },
    form: [
        {
            // Write-only: the field is empty on load and only submits when the
            // user types a new value, so opening an existing secret and saving
            // (without touching this field) never overwrites the stored secret
            // with the masked placeholder. Same pattern as vault_config's
            // password/token fields.
            name: "value",
            component: "writeOnlyInput",
            fieldProps: {
                label: "Secret value",
                clearable: true,
                docs: {
                    text: "The secret value. Encrypted at rest and never shown again after saving; reference it in a flow via `system.secret('<name>')`.",
                    url: "/docs/named-secrets",
                },
            },
            fieldAttr: {
                placeholder: "Enter the secret value",
            },
        },
    ],
};
export default config;
